import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";

import { QueryKeys, useInvalidateQuery } from "@/queries/utils";

interface DeleteInterviewParams {
  openingId: string;
  interviewId: string;
}

export const useDeleteInterview = () => {
  const invalidate = useInvalidateQuery();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async ({ interviewId }: DeleteInterviewParams) => {
      const token = await getAccessTokenSilently();

      await request({
        method: "DELETE",
        path: `/api/interview/${interviewId}/`,
        token,
      });
    },
    onSettled: async (_, __, { openingId }) => {
      await invalidate(QueryKeys.companyOpportunities);
      await invalidate(QueryKeys.companyOpportunity(openingId));
    },
  });

  return {
    deleteInterview: mutate,
    isDeleting: isPending,
    deleteError: error,
  };
};
